export default "__VITE_ASSET__DJclqi_y__"